import { userData } from '@signals'

// Accounts with DS Repricing open a pass in the same field (CU-869fmm944, criterion 13); the others read the text of before
export const hasRepricing = () => !!userData.value?.featuresV2?.ds_repricing

export const SELECTOR_PASS_TEXT = {
	es: ' Con DS Repricing, la pastilla «Repricing» del mismo campo abre una pasada del motor: sus precios por site, comparados con la pasada anterior que buscó cada celda.',
	en: ' With DS Repricing, the "Repricing" pill of the same field opens a pass of the engine: its prices per site, compared with the previous pass that searched each cell.',
}

export const LINKS_PASS_TEXT = {
	es: ' Con una pasada de repricing abierta solo aparece el otro analizador que la sabe abrir (DOR o LOR).',
	en: ' With a repricing pass open only the other analyzer that opens it (DOR or LOR) appears.',
}
